import { Box, Text, colors } from '@factorialco/deprecated-design-system'
import { ResponsiveLine } from '@nivo/line'

import i18n from 'modules/core/lib/i18n'

import { EvolutionTransformedData } from 'modules/project_management/components/charts/EvolutionChart/getEvolutionTransformedData'
import { mockSkeletonData } from 'modules/project_management/components/graphs/EvolutionGraph/EvolutionGraphMockUp/mockSkeletonData'

const EvolutionGraphMockUp = () => {
  const mockData: EvolutionTransformedData = {
    id: 'registered_hours',
    label: i18n.t('project_management.graphs.evolution.time.legends.registered_hours'),
    max: 400,
    min: 0,
    data: mockSkeletonData,
    color: 'viridian1000',
  }
  return (
    <Box gap="s12" width="full">
      <Text.Normal color={'grey800'} weight="medium" size="300">
        {i18n.t('project_management.graphs.evolution.time.subtitles.current_week')}
      </Text.Normal>
      <Box height="s400" width="full">
        <ResponsiveLine
          data={[mockData]}
          margin={{ left: 64, top: 10, bottom: 64, right: 64 }}
          xScale={{ type: 'linear' }}
          yScale={{
            type: 'linear',
            min: 0,
            max: mockData.max,
            stacked: false,
            reverse: false,
          }}
          axisLeft={{
            tickSize: 0,
            tickPadding: 14,
            tickRotation: 0,
            tickValues: 4,
            format: (value) => `${value} h`,
          }}
          enableGridY
          gridYValues={1}
          colors={colors.grey400}
          yFormat=" >-.2f"
          axisTop={null}
          axisRight={null}
          axisBottom={{
            tickSize: 0,
            tickRotation: 0,
            tickPadding: 14,
            tickValues: 7,

            renderTick: ({ textAnchor, textBaseline, textX, textY, value, x, y }) => {
              return (
                <g transform={`translate(${x},${y + 8})`}>
                  <text
                    color={colors.grey1000}
                    textAnchor={textAnchor}
                    transform={`translate(${textX},${textY + 10})`}
                  >
                    {
                      <tspan color={colors.grey1000}>
                        {(mockData.data[value] || {}).title || 84}{' '}
                      </tspan>
                    }
                  </text>
                </g>
              )
            },
          }}
          pointSize={7}
          pointBorderWidth={2}
          pointLabelYOffset={-12}
          useMesh
          enableGridX={false}
          enableSlices="x"
          sliceTooltip={undefined}
          enablePoints={false}
          isInteractive={false}
          pointBorderColor={colors.grey1000}
          theme={{
            axis: {
              ticks: {
                text: {
                  fill: colors.grey1000, // colour of lateral text
                },
                line: {
                  strokeWidth: 0,
                  fill: colors.grey1000,
                },
              },
              legend: {
                text: {
                  fill: colors.grey1000,
                },
              },
              domain: {
                line: { fill: colors.grey1000 },
              },
            },
          }}
        />
      </Box>
    </Box>
  )
}

export default EvolutionGraphMockUp
